import React, { useEffect, useRef, useState } from "react";
import Wrapper from "../../components/wrapper/Wrapper";
import { BsThreeDotsVertical } from "react-icons/bs";
import ImagePopUpModal from "../../components/Modal/ImagePopUpModal";
import SimplePagination from "../../components/Pagination/SimplePagination";
import {
  FiFilter,
  FiUser,
  FiImage,
  FiLayers,
  FiEye,
  FiCheck,
  FiX,
  FiClock,
  FiEdit2,
} from "react-icons/fi";
import {
  editMerchandiseRequestStatus,
  getMerchandiseRequest,
  editMerchandiseRequestDetails,
} from "../../API/MerchandiseRequestAPI/MerchandiseRequestAPI";
import Loader from "../../components/Loader/Loader";
import EditMerchandiseRequestModel from "../../components/Modal/EditMerchandiseRequestModel";
import EditMerchandiseDetailsModal from "../../components/Modal/EditMerchandiseDetailsModal";
import ApproveWithProductLinkModal from "../../components/Modal/ApproveWithProductLinkModal";
import toast from "react-hot-toast";

function MerchandiseRequests() {
  const [filterOpen, setFilterOpen] = useState(false);
  const [statusFilter, setStatusFilter] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageLimit, setPageLimit] = useState(10);
  const [pageLoading, setPageLoading] = useState(false);
  const [merchandiseRequests, setMerchandiseRequests] = useState([]);
  const [isEditMerchandiseRequestModel, setIsEditMerchandiseRequestModel] =
    useState({
      isOpen: false,
      _id: null,
      status: null,
    });
  const [
    isEditMerchandiseRequestStatusLoading,
    setIsEditMerchandiseRequestStatusLoading,
  ] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedRequestForEdit, setSelectedRequestForEdit] = useState(null);
  const [approveModalOpen, setApproveModalOpen] = useState(false);
  const [selectedRequestForApprove, setSelectedRequestForApprove] = useState(null);
  const [approvingRequest, setApprovingRequest] = useState(false);
  const handleFilter = (status) => {
    setStatusFilter(status);
    setPageNumber(1);
    setFilterOpen(false);
  };
  const [showModal, setShowModal] = useState({
    rowId: null,
  });
  const [statusChange, setstatusChange] = useState({
    loader: false,
    _id: null,
    status: null,
  });
  const menuRef = useRef(null);

  const fetchMerchandiseRequest = async ({ status, page, limit }) => {
    try {
      setPageLoading(true);
      const response = await getMerchandiseRequest({ status, page, limit });
      setMerchandiseRequests(response);
    } catch (error) {
      console.log("error in fetchMerchandiseRequest", error);
    } finally {
      setPageLoading(false);
    }
  };

  useEffect(() => {
    fetchMerchandiseRequest({
      status: statusFilter,
      page: pageNumber,
      limit: pageLimit,
    });
  }, [statusFilter, pageNumber, pageLimit]);

  const handleEditMerchandiseRequestStatus = async ({
    productLink,
    description,
    status,
    _id,
  }) => {
    try {
      setstatusChange({
        _id: _id,
        loader: true,
        status,
      });
      setIsEditMerchandiseRequestStatusLoading(true);
      const response = await editMerchandiseRequestStatus({
        _id: _id,
        status,
        productLink: productLink ? productLink : null,
        description: description ? description : null,
      });
      const newMerchandiseRequests =
        merchandiseRequests.merchandiseProductRequests.map((item) => {
          if (
            item.merchandiseProductRequest._id.toString() ===
            response.merchandiseProductRequest._id.toString()
          ) {
            return response;
          } else {
            return item;
          }
        });
      setMerchandiseRequests({
        ...merchandiseRequests,
        merchandiseProductRequests: newMerchandiseRequests,
      });

      // Show appropriate success message based on status
      if (status === 1) {
        toast.success("Request approved successfully");
      } else if (status === 2) {
        toast.success("Request rejected successfully");
      } else {
        toast.success("Request status updated successfully");
      }

      // Close menu after successful operation
      setstatusChange({
        _id: null,
        loader: false,
        status: null,
      });
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Error updating request status"
      );
      // Close menu even on error
      setstatusChange({
        _id: null,
        loader: false,
        status: null,
      });
    } finally {
      setIsEditMerchandiseRequestStatusLoading(false);
    }
  };

  useEffect(() => {
    const handleOutsideClick = (e) => {
      // Don't close menu if clicking on a button inside the menu
      if (
        e.target.closest("button") &&
        menuRef.current &&
        menuRef.current.contains(e.target)
      ) {
        return;
      }

      const clickedElement = e.target.closest("#BsThreeDotsVertical");
      if (clickedElement) {
        const value = clickedElement.getAttribute("value");
        if (
          showModal.rowId &&
          value &&
          showModal.rowId.toString() === value.toString()
        ) {
          setShowModal({
            rowId: null,
          });
          setstatusChange({ loader: false, _id: null });
        } else {
          setstatusChange(() => ({
            loader: false,
            _id: value,
          }));
        }
      } else if (menuRef.current && !menuRef.current.contains(e.target)) {
        setstatusChange({ loader: false, _id: null });
      }
    };

    // Add the event listener
    document.addEventListener("mousedown", handleOutsideClick);

    // Cleanup function to remove the event listener
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleLimitChange = async (newLimit) => {
    setPageLimit(newLimit);
    setPageNumber(1);
  };

  const handleEditRequestDetails = async (id, payload) => {
    try {
      const response = await editMerchandiseRequestDetails(id, payload);

      // Update the local state with the edited request
      const updatedRequests =
        merchandiseRequests.merchandiseProductRequests.map((item) => {
          if (item.merchandiseProductRequest._id.toString() === id.toString()) {
            // Properly merge the response with existing item structure
            return {
              ...item,
              merchandiseProductRequest: {
                ...item.merchandiseProductRequest,
                ...response.merchandiseProductRequest,
              },
              merchandiseProduct:
                response.merchandiseProduct || item.merchandiseProduct,
              user: response.user || item.user,
            };
          }
          return item;
        });

      setMerchandiseRequests({
        ...merchandiseRequests,
        merchandiseProductRequests: updatedRequests,
      });

      toast.success("Request details updated successfully");
      setEditModalOpen(false);
      setSelectedRequestForEdit(null);
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Error updating request details"
      );
      throw error;
    }
  };

  const handleApproveWithLink = async (productLink) => {
    setApprovingRequest(true);
    try {
      await handleEditMerchandiseRequestStatus({
        _id: selectedRequestForApprove._id,
        status: 1,
        productLink: productLink,
      });
      
      toast.success("Request approved successfully with product link");
      setApproveModalOpen(false);
      setSelectedRequestForApprove(null);
    } catch (error) {
      toast.error("Error approving request");
    } finally {
      setApprovingRequest(false);
    }
  };

  return (
    <Wrapper>
      {/* Header Section */}
      <div className="mb-8">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div>
            <h1 className="text-2xl font-semibold text-gray-900">
              Merchandise Requests
            </h1>
            <p className="text-gray-600 mt-1">
              Review and manage product customization requests
            </p>
          </div>
          <div className="relative">
            <button
              onClick={() => setFilterOpen((prev) => !prev)}
              className="inline-flex items-center gap-2 px-4 py-2 bg-[--primary] text-white rounded-lg hover:bg-[--primary]/90 transition-colors font-medium"
            >
              <FiFilter className="w-4 h-4" />
              <span>Filter</span>
            </button>
            {filterOpen && (
              <div className="absolute top-12 right-0 w-48 bg-white border border-gray-200 shadow-lg rounded-lg py-1 z-10">
                <button
                  onClick={() => handleFilter(0)}
                  className="w-full px-4 py-2 text-sm text-left text-gray-700 hover:bg-gray-50 flex items-center gap-2"
                >
                  <FiClock className="w-4 h-4" />
                  Pending
                </button>
                <button
                  onClick={() => handleFilter(1)}
                  className="w-full px-4 py-2 text-sm text-left text-gray-700 hover:bg-gray-50 flex items-center gap-2"
                >
                  <FiCheck className="w-4 h-4" />
                  Approved
                </button>
                <button
                  onClick={() => handleFilter(2)}
                  className="w-full px-4 py-2 text-sm text-left text-gray-700 hover:bg-gray-50 flex items-center gap-2"
                >
                  <FiX className="w-4 h-4" />
                  Rejected
                </button>
                <div className="border-t border-gray-100 my-1"></div>
                <button
                  onClick={() => handleFilter(null)}
                  className="w-full px-4 py-2 text-sm text-left text-gray-700 hover:bg-gray-50"
                >
                  All Requests
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* Requests Table */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
        {merchandiseRequests &&
        merchandiseRequests?.merchandiseProductRequests &&
        !pageLoading ? (
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50 border-b border-gray-200">
                <tr>
                  <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Product
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Design
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Final Product
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Customer
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Price
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Variants
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Status
                  </th>
                  <th className="px-6 py-4 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {merchandiseRequests?.merchandiseProductRequests.map((item) => {
                  return (
                    <tr
                      key={`request-${item.merchandiseProductRequest._id}-${
                        item.merchandiseProductRequest.updatedAt || Date.now()
                      }`}
                      className="hover:bg-gray-50 transition-colors"
                    >
                      {/* Product Column */}
                      <td className="px-6 py-4">
                        <div className="flex items-center gap-3">
                          <div className="flex-shrink-0">
                            {item?.merchandiseProduct?.productImage?.length >
                            0 ? (
                              <div className="flex gap-1">
                                <ImagePopUpModal
                                  imageUrl={
                                    item.merchandiseProduct.productImage[0]
                                  }
                                  customClass="w-12 h-12 object-cover rounded-lg border border-gray-200"
                                  alt="Product"
                                />
                                {item.merchandiseProduct.productImage.length >
                                  1 && (
                                  <div className="w-12 h-12 bg-gray-100 rounded-lg border border-gray-200 flex items-center justify-center text-xs text-gray-500">
                                    +
                                    {item.merchandiseProduct.productImage
                                      .length - 1}
                                  </div>
                                )}
                              </div>
                            ) : (
                              <div className="w-12 h-12 bg-gray-100 rounded-lg border border-gray-200 flex items-center justify-center">
                                <FiEye className="w-5 h-5 text-gray-400" />
                              </div>
                            )}
                          </div>
                          <div className="min-w-0 flex-1">
                            <h3 className="text-sm font-medium text-gray-900 truncate">
                              {item.merchandiseProduct?.title || "Product"}
                            </h3>
                            <p className="text-sm text-gray-500 truncate">
                              Base Product
                            </p>
                          </div>
                        </div>
                      </td>

                      {/* Design Column */}
                      <td className="px-6 py-4">
                        <div className="flex items-center justify-center">
                          {item.merchandiseProductRequest.design?.[0] ? (
                            <ImagePopUpModal
                              key={`design-${item.merchandiseProductRequest._id}-${item.merchandiseProductRequest.design[0]}`}
                              imageUrl={
                                item.merchandiseProductRequest.design[0]
                              }
                              customClass="w-16 h-16 object-cover rounded-lg border border-gray-200"
                              alt="Requested Design"
                            />
                          ) : (
                            <div className="w-16 h-16 bg-gray-100 rounded-lg border border-gray-200 flex items-center justify-center">
                              <FiImage className="w-6 h-6 text-gray-400" />
                            </div>
                          )}
                        </div>
                      </td>

                      {/* Final Product Column */}
                      <td className="px-6 py-4">
                        <div className="flex items-center justify-center">
                          {item.merchandiseProductRequest.productWithDesign ? (
                            <ImagePopUpModal
                              key={`product-${item.merchandiseProductRequest._id}-${item.merchandiseProductRequest.productWithDesign}`}
                              imageUrl={
                                item.merchandiseProductRequest.productWithDesign
                              }
                              customClass="w-16 h-16 object-cover rounded-lg border border-gray-200"
                              alt="Final Product"
                            />
                          ) : (
                            <div className="w-16 h-16 bg-gray-100 rounded-lg border border-gray-200 flex items-center justify-center">
                              <FiLayers className="w-6 h-6 text-gray-400" />
                            </div>
                          )}
                        </div>
                      </td>

                      {/* Customer Column */}
                      <td className="px-6 py-4">
                        <div className="flex items-center gap-3">
                          <div className="flex-shrink-0">
                            <div className="w-10 h-10 bg-[--primary] rounded-full flex items-center justify-center">
                              <FiUser className="w-5 h-5 text-white" />
                            </div>
                          </div>
                          <div className="min-w-0 flex-1">
                            <h3 className="text-sm font-medium text-gray-900">
                              {item.user.firstName} {item.user.lastName}
                            </h3>
                            <p className="text-sm text-gray-500">
                              {item.user.phoneNumber}
                            </p>
                          </div>
                        </div>
                      </td>

                      {/* Price Column */}
                      <td className="px-6 py-4">
                        <div className="text-sm font-semibold text-gray-900">
                          ${item.merchandiseProductRequest.price}
                        </div>
                      </td>

                      {/* Variants Column */}
                      <td className="px-6 py-4">
                        <div
                          className="space-y-2"
                          key={`variants-${item.merchandiseProductRequest._id}-${item.merchandiseProductRequest.updatedAt}`}
                        >
                          {/* Colors */}
                          {item.merchandiseProductRequest.color?.length > 0 && (
                            <div className="flex items-center gap-2">
                              <span className="text-xs text-gray-500">
                                Colors:
                              </span>
                              <div className="flex gap-1">
                                {item.merchandiseProductRequest.color
                                  .slice(0, 3)
                                  .map((color, idx) => (
                                    <div
                                      key={`${color}-${idx}`}
                                      className="w-4 h-4 rounded-full border border-gray-300"
                                      style={{ backgroundColor: color }}
                                      title={color}
                                    ></div>
                                  ))}
                                {item.merchandiseProductRequest.color.length >
                                  3 && (
                                  <span className="text-xs text-gray-500">
                                    +
                                    {item.merchandiseProductRequest.color
                                      .length - 3}
                                  </span>
                                )}
                              </div>
                            </div>
                          )}
                          {/* Sizes */}
                          {item.merchandiseProductRequest.size?.length > 0 && (
                            <div className="flex items-center gap-2">
                              <span className="text-xs text-gray-500">
                                Sizes:
                              </span>
                              <div className="flex gap-1 flex-wrap">
                                {item.merchandiseProductRequest.size
                                  .slice(0, 4)
                                  .map((size, idx) => (
                                    <span
                                      key={`${size}-${idx}`}
                                      className="px-2 py-1 text-xs bg-gray-100 text-gray-700 rounded"
                                    >
                                      {size}
                                    </span>
                                  ))}
                                {item.merchandiseProductRequest.size.length >
                                  4 && (
                                  <span className="text-xs text-gray-500">
                                    +
                                    {item.merchandiseProductRequest.size
                                      .length - 4}
                                  </span>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      </td>

                      {/* Status Column */}
                      <td className="px-6 py-4">
                        <span
                          className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                            item.merchandiseProductRequest.status === 0
                              ? "bg-yellow-100 text-yellow-800"
                              : item.merchandiseProductRequest.status === 1
                              ? "bg-green-100 text-green-800"
                              : "bg-red-100 text-red-800"
                          }`}
                        >
                          {item.merchandiseProductRequest.status === 0 ? (
                            <>
                              <FiClock className="w-3 h-3 mr-1" />
                              Pending
                            </>
                          ) : item.merchandiseProductRequest.status === 1 ? (
                            <>
                              <FiCheck className="w-3 h-3 mr-1" />
                              Approved
                            </>
                          ) : (
                            <>
                              <FiX className="w-3 h-3 mr-1" />
                              Rejected
                            </>
                          )}
                        </span>
                      </td>
                      {/* Actions Column */}
                      <td className="px-6 py-4 text-center">
                        <div
                          className="relative"
                          ref={menuRef}
                          data-actions-menu
                        >
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              const value = item.merchandiseProductRequest._id;
                              if (
                                statusChange._id &&
                                statusChange._id.toString() === value.toString()
                              ) {
                                setstatusChange({ loader: false, _id: null });
                              } else {
                                setstatusChange({ loader: false, _id: value });
                              }
                            }}
                            className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
                          >
                            <BsThreeDotsVertical className="w-4 h-4" />
                          </button>

                          {statusChange._id ===
                            item.merchandiseProductRequest._id && (
                            <div className="absolute right-0 top-8 bg-white border border-gray-200 shadow-lg rounded-lg py-1 z-10 min-w-[140px]">
                              {/* Edit Button - Always visible */}
                              <button
                                onMouseDown={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  setSelectedRequestForEdit(item);
                                  setEditModalOpen(true);
                                  setstatusChange({ loader: false, _id: null });
                                }}
                                className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2"
                              >
                                <FiEdit2 className="w-4 h-4" />
                                Edit Details
                              </button>
                              <div className="border-t border-gray-100 my-1"></div>

                              {item.merchandiseProductRequest.status === 0 && (
                                <>
                                  <button
                                    onMouseDown={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      setSelectedRequestForApprove({
                                        _id: item.merchandiseProductRequest._id,
                                      });
                                      setApproveModalOpen(true);
                                      setstatusChange({ loader: false, _id: null });
                                    }}
                                    className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2"
                                  >
                                    <FiCheck className="w-4 h-4" />
                                    Approve
                                  </button>
                                  <button
                                    onMouseDown={async (e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      await handleEditMerchandiseRequestStatus({
                                        _id: item.merchandiseProductRequest._id,
                                        status: 2,
                                      });
                                    }}
                                    className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                                    disabled={
                                      statusChange.loader &&
                                      statusChange._id ===
                                        item.merchandiseProductRequest._id
                                    }
                                  >
                                    {statusChange.loader &&
                                    statusChange._id ===
                                      item.merchandiseProductRequest._id &&
                                    statusChange.status === 2 ? (
                                      <>
                                        <div className="w-4 h-4 border-2 border-gray-600 border-t-transparent rounded-full animate-spin"></div>
                                        Rejecting...
                                      </>
                                    ) : (
                                      <>
                                        <FiX className="w-4 h-4" />
                                        Reject
                                      </>
                                    )}
                                  </button>
                                </>
                              )}
                              {item.merchandiseProductRequest.status === 1 && (
                                <>
                                  <button
                                    onMouseDown={async (e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      await handleEditMerchandiseRequestStatus({
                                        _id: item.merchandiseProductRequest._id,
                                        status: 0,
                                      });
                                    }}
                                    className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                                    disabled={
                                      statusChange.loader &&
                                      statusChange._id ===
                                        item.merchandiseProductRequest._id
                                    }
                                  >
                                    {statusChange.loader &&
                                    statusChange._id ===
                                      item.merchandiseProductRequest._id &&
                                    statusChange.status === 0 ? (
                                      <>
                                        <div className="w-4 h-4 border-2 border-gray-600 border-t-transparent rounded-full animate-spin"></div>
                                        Updating...
                                      </>
                                    ) : (
                                      <>
                                        <FiClock className="w-4 h-4" />
                                        Pending
                                      </>
                                    )}
                                  </button>
                                  <button
                                    onMouseDown={async (e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      await handleEditMerchandiseRequestStatus({
                                        _id: item.merchandiseProductRequest._id,
                                        status: 2,
                                      });
                                    }}
                                    className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                                    disabled={
                                      statusChange.loader &&
                                      statusChange._id ===
                                        item.merchandiseProductRequest._id
                                    }
                                  >
                                    {statusChange.loader &&
                                    statusChange._id ===
                                      item.merchandiseProductRequest._id &&
                                    statusChange.status === 2 ? (
                                      <>
                                        <div className="w-4 h-4 border-2 border-gray-600 border-t-transparent rounded-full animate-spin"></div>
                                        Rejecting...
                                      </>
                                    ) : (
                                      <>
                                        <FiX className="w-4 h-4" />
                                        Reject
                                      </>
                                    )}
                                  </button>
                                </>
                              )}
                              {item.merchandiseProductRequest.status === 2 && (
                                <>
                                  <button
                                    onMouseDown={async (e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      await handleEditMerchandiseRequestStatus({
                                        _id: item.merchandiseProductRequest._id,
                                        status: 0,
                                      });
                                    }}
                                    className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                                    disabled={
                                      statusChange.loader &&
                                      statusChange._id ===
                                        item.merchandiseProductRequest._id
                                    }
                                  >
                                    {statusChange.loader &&
                                    statusChange._id ===
                                      item.merchandiseProductRequest._id &&
                                    statusChange.status === 0 ? (
                                      <>
                                        <div className="w-4 h-4 border-2 border-gray-600 border-t-transparent rounded-full animate-spin"></div>
                                        Updating...
                                      </>
                                    ) : (
                                      <>
                                        <FiClock className="w-4 h-4" />
                                        Pending
                                      </>
                                    )}
                                  </button>
                                  <button
                                    onMouseDown={async (e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      await handleEditMerchandiseRequestStatus({
                                        _id: item.merchandiseProductRequest._id,
                                        status: 1,
                                      });
                                    }}
                                    className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                                    disabled={
                                      statusChange.loader &&
                                      statusChange._id ===
                                        item.merchandiseProductRequest._id
                                    }
                                  >
                                    {statusChange.loader &&
                                    statusChange._id ===
                                      item.merchandiseProductRequest._id &&
                                    statusChange.status === 1 ? (
                                      <>
                                        <div className="w-4 h-4 border-2 border-gray-600 border-t-transparent rounded-full animate-spin"></div>
                                        Approving...
                                      </>
                                    ) : (
                                      <>
                                        <FiCheck className="w-4 h-4" />
                                        Approve
                                      </>
                                    )}
                                  </button>
                                </>
                              )}
                            </div>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="flex justify-center items-center py-12">
            <Loader />
          </div>
        )}

        {/* Empty State */}
        {!pageLoading &&
          merchandiseRequests?.merchandiseProductRequests?.length === 0 && (
            <div className="text-center py-12">
              <div className="mx-auto w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                <FiLayers className="w-12 h-12 text-gray-400" />
              </div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">
                No requests found
              </h3>
              <p className="text-gray-500">
                No merchandise requests match your current filter.
              </p>
            </div>
          )}
      </div>
      {isEditMerchandiseRequestModel.isOpen && (
        <EditMerchandiseRequestModel
          isOpen={true}
          onClose={() => setIsEditMerchandiseRequestModel(false)}
          onSubmit={handleEditMerchandiseRequestStatus}
          isSubmitLoding={isEditMerchandiseRequestStatusLoading}
          _id={isEditMerchandiseRequestModel._id}
          status={isEditMerchandiseRequestModel.status}
        />
      )}

      {/* Edit Request Details Modal */}
      {editModalOpen && selectedRequestForEdit && (
        <EditMerchandiseDetailsModal
          isOpen={editModalOpen}
          onClose={() => {
            setEditModalOpen(false);
            setSelectedRequestForEdit(null);
          }}
          onSubmit={handleEditRequestDetails}
          requestData={selectedRequestForEdit}
        />
      )}

      {/* Approve with Product Link Modal */}
      {approveModalOpen && selectedRequestForApprove && (
        <ApproveWithProductLinkModal
          isOpen={approveModalOpen}
          onClose={() => {
            setApproveModalOpen(false);
            setSelectedRequestForApprove(null);
          }}
          onSubmit={handleApproveWithLink}
          isLoading={approvingRequest}
        />
      )}

      <SimplePagination
        totalPages={merchandiseRequests?.paginationInfo?.totalPages || 0}
        currentPage={merchandiseRequests?.paginationInfo?.currentPage || 1}
        onPageChange={setPageNumber}
        limit={pageLimit || 10}
        onLimitChange={handleLimitChange}
        totalItems={merchandiseRequests?.paginationInfo?.totalItems || 0}
      />
    </Wrapper>
  );
}

export default MerchandiseRequests;
